/*
  Generation design item sourceType
*/
export enum ExternalType {
  Manual = 'MANUAL',  // means null, not run homer
  Verified = 'EXTERNAL_VERIFIED', // Run homer but using our capacity (or quantity of storage): In homer, they calls "Search Space"
  Optimized = 'EXTERNAL_OPTIMIZED'  // Run homer and homer optimize a capacity (or quantity of storage)
}
